import { render, staticRenderFns } from "./HouseTabFiles.vue?vue&type=template&id=5b38b488&scoped=true&"
import script from "./HouseTabFiles.vue?vue&type=script&lang=js&"
export * from "./HouseTabFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b38b488",
  null
  
)

export default component.exports